import { AutomationStep } from '@/types/automationSteps.ts';
import { ConditionAction } from '@/types/automationFields.ts';
import { isStepWithChildren } from '@/utils/stepUtils.ts';

export function protectedLeafOptions(
  children: AutomationStep[],
  isDisabledByAncestor = false,
): { value: string; label: string }[] {
  const leaves: { value: string; label: string }[] = [];
  const visit = (
    candidate: AutomationStep,
    disabledByAncestor: boolean,
    disabledByConditionalBranch = false,
  ) => {
    // A nested Error Boundary has its own protected/recovery audiences. Its
    // descendants must not be selectable by the outer boundary.
    if ('handler_children' in candidate) return;
    const disabled = disabledByAncestor || candidate.is_disabled;
    const nested = 'children' in candidate && Array.isArray(candidate.children) ? candidate.children : [];
    if ('conditions' in candidate && Array.isArray(candidate.conditions)) {
      candidate.conditions
        .filter((condition) => condition.action === ConditionAction.ChildSteps)
        .forEach((condition) => {
          (condition.children || []).forEach((child) =>
            visit(child, disabled, disabledByConditionalBranch || condition.is_disabled),
          );
        });
      return;
    }
    if (nested.length === 0) {
      if (!disabled && !isStepWithChildren(candidate)) {
        const label = candidate.name || candidate.step_id;
        leaves.push({
          value: candidate.step_id,
          label: disabledByConditionalBranch ? `${label} (Disabled branch)` : label,
        });
      }
      return;
    }
    nested.forEach((child) => visit(child, disabled, disabledByConditionalBranch));
  };
  children.forEach((child) => visit(child, isDisabledByAncestor));
  return leaves;
}
